//@ts-check
import { entitlementApiClient } from '../../utils/RequestClient';
import RequestSearchParams from '../../utils/RequestSearchParams';

/**
 * @param {object} params
 * @param {string} params.clientId
 * @param {string} params.orgId
 * @param {string} params.token
 * @returns {Promise<{ state: string, nonce: string }>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/ecApp').MyxchngApiErrorResponse>}
 */
const generateStateToken = async ({ token, clientId, orgId }) => {
  const searchParams = new RequestSearchParams({ clientId, orgId });
  const { textResponse: state, fetchResponse } = await entitlementApiClient.fetch({
    endpoint: `/generateStateToken${searchParams}`,
    requestOptions: {
      credentials: 'include',
      method: 'POST',
      parseBodyOnSuccess: false,
      parseBodyOnError: true,
      headers: {
        authorization: `Bearer ${token}`,
        accept: 'application/json, text/plain',
      },
    },
  });
  const nonce = fetchResponse.headers.get('x-nonce');
  return { state, nonce };
};

export default generateStateToken;
